/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:50:41
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-14 16:57:58
 */

/**
 * Interactions template
 * @returns string
 */
export default (): string => {
  return `
    <div class="md-body interactions-panel">
      <div class="tabs">
        <div class="tab">
          <a href="#">Animations</a>
          <i class="gpicon-info"></i>
        </div>
        <div class="tab-action">
          <div class="tab-action-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="7" width="2" height="16" fill="#F8F8F8"/>
              <rect y="9" width="2" height="16" transform="rotate(-90 0 9)" fill="#F8F8F8"/>
            </svg>
          </div>
          <div class="tab-action-dropdown">
            <div class="dropdown-item"></div>
            <div class="dropdown-item"></div>
            <div class="dropdown-item"></div>
          </div>
        </div>
      </div>
      <div class="interactions-body">
        <div class="interactions-overlay"></div>
        <div class="interactions-list">
          <div class="interactions-empty">
            <svg width="73" height="48" viewBox="0 0 73 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16.0481" cy="20" r="16" fill="#353535"/>
              <circle cx="30.0481" cy="19" r="17.5" fill="#484848" stroke="#252525" stroke-width="3"/>
              <circle cx="44.0481" cy="19" r="17.5" fill="#616161" stroke="#252525" stroke-width="3"/>
              <path d="M72.9506 33.9046C72.9248 34.5134 72.5248 35.0426 71.946 35.2335L63.1752 38.127L60.2817 46.8978C60.0908 47.4766 59.5616 47.8765 58.9528 47.9024C58.3339 47.9279 57.7792 47.5659 57.5435 47.0138L48.1695 25.0434C47.6526 23.8319 48.88 22.6046 50.0915 23.1213L72.062 32.4953C72.6224 32.7346 72.9763 33.2958 72.9506 33.9046ZM67.3437 33.6672L52.2943 27.2461L58.7154 42.2955L60.6246 36.5084C60.77 36.0675 61.1158 35.7218 61.5566 35.5764L67.3437 33.6672Z" fill="#F5F5F5"/>
              <path d="M48.779 12.7996L48.7211 17.5416M53.8485 20.0538L56.4133 17.2935M40.7187 17.6711L44.0709 20.3872" stroke="#FCFCFC" stroke-width="3" stroke-linecap="round"/>
            </svg>
            <p class="interactions-empty-text">Press "<span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="7" width="2" height="16" fill="#F8F8F8"/>
              <rect y="9" width="2" height="16" transform="rotate(-90 0 9)" fill="#F8F8F8"/>
              </svg>
            </span>" button to add new interaction trigger with animation</p>
          </div>
        </div>
      </div>
    </div>
  `;
};
